module.exports = __webpack_public_path__ + "static/media/lili2_edited.e772e834.jpg";